import { observer } from 'mobx-react-lite';
import { style } from './ProductOptionsMobile.style';
import { Pressable, View } from 'react-native';
import { Icon } from '../icon/Icon';
import TextLato from '../text/text-lato/TextLato';
import { ICON_NAMES } from '../icon/icon.helper';
import { useStore } from 'src/contexts/StoreContext';
import { brand } from 'src/theme/colors';
import { useGridItemContentFooterLogic } from '../product-groups/grid-item-content/grid-item-content-footer/GridItemContentFooter.logic';
import { ProductOptionsMobileProps } from './ProductOptionsMobile.types';
import { useGridItemContentHeaderLogic } from '../product-groups/grid-item-content/grid-item-content-header/GridItemContentHeader.logic';

export const ProductOptionsMobile = observer(
  ({ product, containerStyle, avoidCounterAction }: ProductOptionsMobileProps) => {
    const { i18n } = useStore();
    const { productCount, addProduct, subtractProduct, removeProduct } = useGridItemContentFooterLogic(product);
    const { onPressEdit, isMultiphotoProductComplete } = useGridItemContentHeaderLogic(product);

    return (
      <View style={[style.dropdownContainer, containerStyle]}>
        <View style={style.actionsWrapper}>
          <Pressable style={style.action} onPress={() => onPressEdit(isMultiphotoProductComplete)}>
            <View style={style.actionIcon}>
              <Icon name={ICON_NAMES.Edit} color={brand.main.water} />
            </View>
            <TextLato style={style.actionText}>{i18n.t('actions:edit')}</TextLato>
          </Pressable>
          <Pressable style={style.action} onPress={product.duplicate}>
            <View style={style.actionIcon}>
              <Icon name={ICON_NAMES.Copy} color={brand.main.water} />
            </View>
            <TextLato style={style.actionText}>{i18n.t('actions:duplicate')}</TextLato>
          </Pressable>
        </View>
        {!avoidCounterAction && (
          <View style={style.counter}>
            <Pressable onPress={productCount > 1 ? subtractProduct : removeProduct}>
              <View style={style.iconCounter}>
                <Icon name={productCount > 1 ? ICON_NAMES.Minus : ICON_NAMES.Delete} color={brand.main.water} />
              </View>
            </Pressable>

            <TextLato style={style.countText}>{productCount}</TextLato>
            <Pressable onPress={addProduct}>
              <View style={style.iconCounter}>{<Icon name={ICON_NAMES.Plus} color={brand.main.water} />}</View>
            </Pressable>
          </View>
        )}
      </View>
    );
  },
);
